import api from "../../Services/api";
import React, { useEffect, useState, useRef, useMemo } from "react";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { useNavigate } from "react-router-dom";
import GridRegistros from "../../Componentes/GridRegistros";
import Swal from "sweetalert2";
import { formatCNPJ } from "../../Services/formatCNPJ";
import Modal from 'react-modal';
import "./index.css";

const CadastroPlanejamento = () => {
  const [permissoes, setPermissoes] = useState([]);
  const [ListPerguntas, setListPerguntas] = useState([])
  const { authReady } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();
  const [listProcessos, setListProcessos] = useState([]);

  const [modalAberto, setModalAberto] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [perguntasEditando, setPerguntasEditando] = useState([]);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState("__todas__");

  // Modal de edição individual
  const [modalPerguntaAberto, setModalPerguntaAberto] = useState(false);
  const [perguntaSelecionada, setPerguntaSelecionada] = useState(null);

  const [clienteInfo, setClienteInfo] = useState({ nome: "", cnpj: "" });


  const navigate = useNavigate();
  let idFormatado = String(IDOperador).padStart(6, '0');

  useEffect(function () {
    if (!operador && !authReady) {
      navigate("/");
    }
  }, [operador]);

  useEffect(() => {
    carregarPermissoes();
    carregarListaPerguntas();
  }, []);

  const exibirErrosValidacao = (err, titulo = "Erro") => {
    const bodyErrors = err.response?.data?.erros?.body;
    if (bodyErrors) {
      const mensagens = Object.entries(bodyErrors)
        .map(([campo, msg]) => `<b>${campo}</b>: ${msg}`)
        .join("<br>");
      Swal.fire({ title: titulo, html: mensagens, icon: "error" });
    } else {
      Swal.fire(titulo, "Erro inesperado ao processar requisição.", "error");
    }
  };

  const carregarPermissoes = async () => {
    try {
      const res = await api.get("/permissoes");
      setPermissoes(res.data);
    } catch (err) {
      console.error("Erro ao carregar cargos", err);
    }
  };

  const carregarListaPerguntas = async () => {
    try {
      const res = await api.get("/planejamento/todasperguntas");
      const perguntas = res.data;
      setListPerguntas(perguntas);

      if (Array.isArray(perguntas)) {
        const processosUnicos = perguntas
          .map((item) => ({
            IDProcesso: item.IDProcesso,
            IDCliente: item.IDCliente,
            Nome: item.Nome,
            CNPJ: formatCNPJ(item.CNPJ),
          }))
          .filter(
            (value, index, self) =>
              index === self.findIndex(
                (v) => v.IDProcesso === value.IDProcesso && v.IDCliente === value.IDCliente
              )
          );
        setListProcessos(processosUnicos);
      }
    } catch (err) {
      console.error("Erro ao carregar perguntas", err);
    }
  };

  const handleEdit = async (registro) => {
    try {
      const res = await api.get(`/planejamento/perguntas/${registro.IDProcesso}`);
      const perguntasPorCategoria = res.data || {};
      const perguntasArray = Object.entries(perguntasPorCategoria).flatMap(([categoria, perguntas]) =>
        perguntas.map((p) => ({ ...p, categoria }))
      );

      console.log(registro);
      setClienteSelecionado({
        nome: registro.Nome,
        cnpj: registro.CNPJ,
        IDCliente: registro.IDCliente,
        IDProcesso: registro.IDProcesso
      });
      setPerguntasEditando(perguntasArray);
      setModalAberto(true);
    } catch (err) {
      console.error("Erro ao carregar perguntas do processo", err);
      setClienteSelecionado({
        nome: registro.Nome,
        cnpj: registro.CNPJ,
        IDCliente: registro.IDCliente,
        IDProcesso: registro.IDProcesso
      });
      setPerguntasEditando([]);
      setModalAberto(true);
    }
  };

  const abrirModalPergunta = (pergunta) => {
    setPerguntaSelecionada(pergunta);
    setModalPerguntaAberto(true);
  };

  const salvarPergunta = async () => {
    try {
      await api.put(`/planejamento/perguntas/alteracoesByIDpergunta`, perguntaSelecionada);
      setModalPerguntaAberto(false);
      carregarListaPerguntas();
      Swal.fire("Editado!", "Pergunta editada com sucesso.", "success");
      handleEdit(clienteSelecionado); // recarrega as perguntas
    } catch (err) {
      console.error("Erro ao salvar pergunta", err);
      exibirErrosValidacao(err, "Erro ao salvar pergunta");
    }
  };

  const deletarPergunta = async (idPergunta) => {
    Swal.fire({
      title: "Tem certeza?",
      text: "Esta ação não poderá ser desfeita!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, deletar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "var(--color-btnCancelar-danger)",
      customClass: {
        popup: 'custom-swal',
        cancelButton: 'swal-cancel-danger',
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.delete(`/planejamento/perguntas/${idPergunta}`);
          Swal.fire("Deletado!", "Pergunta removida com sucesso.", "success");
          setPerguntasEditando((prev) => prev.filter(p => p.IDPlanejamento_perguntas !== idPergunta));
        } catch (err) {
          console.error("Erro ao deletar pergunta", err);
          Swal.fire("Erro", "Não foi possível deletar a pergunta.", "error");
        }
      }
    });
  };

  const perguntasFiltradas = useMemo(() => {
    if (categoriaSelecionada === "__todas__") return perguntasEditando;
    return perguntasEditando.filter(p => p.categoria === categoriaSelecionada);
  }, [perguntasEditando, categoriaSelecionada]);

  const recarregarPerguntasDoCliente = async () => {
    if (!clienteSelecionado) return;
    try {
      const res = await api.get(`/planejamento/perguntas/${clienteSelecionado.IDProcesso}`);
      const perguntasPorCategoria = res.data || {};
      const perguntasArray = Object.entries(perguntasPorCategoria).flatMap(([categoria, perguntas]) =>
        perguntas.map((p) => ({ ...p, categoria }))
      );
      setPerguntasEditando(perguntasArray);
    } catch (err) {
      console.error("Erro ao recarregar perguntas do cliente", err);
      setPerguntasEditando([]);
    }
  };


  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />
        <h4 style={{ width: '100%', textAlign: 'center', paddingTop: '50px' }}>Perguntas de Planejamentos</h4>
        <br />
        <div style={{paddingLeft:'1%'}}>
          <GridRegistros
            registros={listProcessos}
            onEdit={handleEdit}
            chaveId="IDProcesso"
            exibirDeletar={false}
            ocultarCampos={[""]}
          />
        </div>
      </div>

      {/* Modal principal (somente exibição) */}
      <Modal
        isOpen={modalAberto}
        onRequestClose={() => setModalAberto(false)}
        contentLabel="Editar Perguntas"
        style={{
          content: {
            maxWidth: "900px",
            margin: "auto",
            padding: "30px",
            maxHeight: "90vh",
            overflowY: "auto"
          }
        }}
      >
        <button
          onClick={() => setModalAberto(false)}
          style={{ position: "absolute", top: "10px", right: "10px", width:'20px', height:'15px' }}
        >
          &times;
        </button>

        <h5>
          Perguntas - {clienteSelecionado?.nome} ({clienteSelecionado?.cnpj})
        </h5>
        <hr />

        <div className="mb-3 text-end">
          <button
            className="btn btn-primary"
            onClick={() => {
              setPerguntaSelecionada({
                pergunta: "",
                prazo: "",
                meta: "",
                obs: "",
                resposta: "",
                categoria: "",
                IDCliente: clienteSelecionado.IDCliente,
                IDProcesso: clienteSelecionado.IDProcesso,
                novaCategoria: false
              });
              setModalPerguntaAberto(true);
            }}
          >
            + Nova Pergunta
          </button>
        </div>

        <div className="mb-3">
          <label>Filtrar por Secretaria:</label>
          <select
            className="form-control"
            value={categoriaSelecionada}
            onChange={(e) => setCategoriaSelecionada(e.target.value)}
          >
            <option value="__todas__">Todas</option>
            {Array.from(new Set(perguntasEditando.map(p => p.categoria))).map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
        <br/><br/>

        {perguntasFiltradas.map((p) => (
          <div key={p.IDPlanejamento_perguntas} className="mb-3 p-3" style={{ background: "#fff", border: "1px solid #ddd", borderRadius: "8px", position: "relative" }}>
            {/* Botões editar/deletar */}
            <div style={{ position: "absolute", top: "10px", right: "10px" }}>
              <button className="btn btn-sm btn-outline-primary me-2" style={{width:'40px'}} onClick={() => abrirModalPergunta(p)}>✏️</button>
              <button className="btn btn-sm btn-outline-danger" style={{width:'40px'}} onClick={() => deletarPergunta(p.IDPlanejamento_perguntas)}>🗑️</button>
            </div>
            <p style={{width:'100%', textAlign:'center'}}><strong>Secretaria: </strong>{p.categoria}</p>
            <p><strong>Pergunta:</strong> {p.pergunta}</p>
            <p><strong>Prazo:</strong> {p.prazo}</p>
            <p><strong>Meta:</strong> {p.meta}</p>
            <p><strong>Indicador:</strong> {p.obs}</p>
            <p><strong>Resposta:</strong> {p.resposta}</p>
          </div>
        ))}

      </Modal>

      {/* Modal de edição individual */}
      <Modal
        isOpen={modalPerguntaAberto}
        onRequestClose={() => setModalPerguntaAberto(false)}
        contentLabel="Editar Pergunta"
        style={{
          content: {
            maxWidth: "600px",
            margin: "auto",
            padding: "30px"
          }
        }}
      >
        <h5>Editar Pergunta</h5>
        {perguntaSelecionada && (
          <>
            <label>Secretaria:</label>
            <select
              className="form-control mb-2"
              value={perguntaSelecionada.novaCategoria ? "__nova__" : perguntaSelecionada.categoria}
              onChange={(e) => {
                if (e.target.value === "__nova__") {
                  setPerguntaSelecionada({ ...perguntaSelecionada, categoria: "", novaCategoria: true });
                } else {
                  setPerguntaSelecionada({ ...perguntaSelecionada, categoria: e.target.value, novaCategoria: false });
                }
              }}
            >
              <option value="">Selecione...</option>
              {Array.from(new Set(perguntasEditando.map(p => p.categoria))).map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
              <option value="__nova__">Nova Categoria</option>
            </select>

            {perguntaSelecionada.novaCategoria && (
              <input
                type="text"
                className="form-control mb-2"
                placeholder="Digite o nome da nova categoria"
                value={perguntaSelecionada.categoria}
                onChange={(e) => setPerguntaSelecionada({ ...perguntaSelecionada, categoria: e.target.value })}
              />
            )}

            <label>Pergunta:</label>
            <input
              className="form-control mb-2"
              value={perguntaSelecionada.pergunta}
              onChange={(e) => setPerguntaSelecionada({ ...perguntaSelecionada, pergunta: e.target.value })}
            />
            <label>Prazo:</label>
            <input
              className="form-control mb-2"
              value={perguntaSelecionada.prazo || ""}
              onChange={(e) => setPerguntaSelecionada({ ...perguntaSelecionada, prazo: e.target.value })}
            />
            <label>Meta:</label>
            <input
              className="form-control mb-2"
              value={perguntaSelecionada.meta || ""}
              onChange={(e) => setPerguntaSelecionada({ ...perguntaSelecionada, meta: e.target.value })}
            />
            <label>Indicador:</label>
            <input
              className="form-control mb-2"
              value={perguntaSelecionada.obs || ""}
              onChange={(e) => setPerguntaSelecionada({ ...perguntaSelecionada, obs: e.target.value })}
            />
            <label>Resposta:</label>
            <textarea
              className="form-control mb-3"
              rows={3}
              value={perguntaSelecionada.resposta || ""}
              onChange={(e) => setPerguntaSelecionada({ ...perguntaSelecionada, resposta: e.target.value })}
            />
            <div className="text-end">
              <button
                className="btn btn-success btn-modal-action"
                style={{ width: '40%' }}
                onClick={async () => {
                  try {
                    const perguntaParaSalvar = {
                      ...perguntaSelecionada,
                      resposta: perguntaSelecionada.resposta ?? ""
                    };
                    
                    if (perguntaParaSalvar.IDPlanejamento_perguntas) {
                      // Edição existente
                      await api.put(`/planejamento/perguntas/alteracoesByIDpergunta`, perguntaParaSalvar);
                    } else {
                      // Nova pergunta
                      await api.post(`/planejamento/perguntas`, perguntaParaSalvar);
                    }
                    setModalPerguntaAberto(false);
                    await recarregarPerguntasDoCliente(); 
                    //carregarListaPerguntas();
                    //handleEdit(clienteSelecionado);
                    Swal.fire("Salvo!", "Pergunta salva com sucesso.", "success");
                  } catch (err) {
                    console.error("Erro ao salvar pergunta", err);
                    exibirErrosValidacao(err, "Erro ao salvar pergunta");
                  }
                }}
              >
                Salvar
              </button>
              <button
                className="btn btn-secondary btn-cancel-danger btn-modal-action me-2"
                style={{ width: '40%', marginLeft: '10px' }}
                onClick={() => setModalPerguntaAberto(false)}
              >
                Cancelar
              </button>
            </div>
          </>
        )}

      </Modal>
    </div>
  );
};

export default CadastroPlanejamento;
